var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, AccordionSet, KeyValue, Checkbox, TextLink, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { FieldRow } from "../../components/FieldRow";
import { AccordionSection } from "../../components/AccordionSection";
import { ExpandCollapseToggle } from "../../components/ExpandCollapseToggle";
import { getBlockReasonTranslation } from "../../utils/blockReason";
import { usePermissions } from "../../hooks/usePermissions";
var ProductNumberDetail = function (_a) {
    var _b, _c, _d, _e, _f;
    var productNumber = _a.productNumber;
    var intl = useIntl();
    var history = useHistory();
    var _g = usePermissions(), canViewPublisherDetail = _g.canViewPublisherDetail, canViewPublisherPrefix = _g.canViewPublisherPrefix;
    var _h = useState({
        general: true,
    }), accordionStatus = _h[0], setAccordionStatus = _h[1];
    var _j = useState(true), expandAll = _j[0], setExpandAll = _j[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            setAccordionStatus({
                general: false,
            });
        }
        else {
            setAccordionStatus({
                general: true,
            });
        }
        setExpandAll(!expandAll);
    };
    var renderPublisherLink = function () {
        var publisher = productNumber.publisher;
        if (!(publisher === null || publisher === void 0 ? void 0 : publisher.sourceId) || !(publisher === null || publisher === void 0 ? void 0 : publisher.name) || !canViewPublisherDetail)
            return (publisher === null || publisher === void 0 ? void 0 : publisher.name) || "";
        return (React.createElement(TextLink, { onClick: function () {
                return history.push("/bragency/publishers/detail?sourceId=".concat(publisher.sourceId));
            } }, publisher.name));
    };
    var renderTitleLink = function () {
        var _a, _b, _c;
        var title = (_a = productNumber.product) === null || _a === void 0 ? void 0 : _a.title;
        if (!(title === null || title === void 0 ? void 0 : title.id))
            return "";
        var titleName = ((_c = (_b = title.names) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.name) || title.id;
        return (React.createElement(TextLink, { onClick: function () { return history.push("/bragency/titles/detail?id=".concat(title.id)); } }, titleName));
    };
    var renderProductLink = function () {
        var _a, _b, _c;
        var product = productNumber.product;
        if (!(product === null || product === void 0 ? void 0 : product.id))
            return "";
        var productName = ((_c = (_b = (_a = product.title) === null || _a === void 0 ? void 0 : _a.names) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.name) || product.id;
        return (React.createElement(TextLink, { onClick: function () { return history.push("/bragency/products/detail/".concat(product.id)); } }, productName));
    };
    var renderPublisherPrefixLink = function () {
        var publisherPrefix = productNumber.publisherPrefix;
        if (!(publisherPrefix === null || publisherPrefix === void 0 ? void 0 : publisherPrefix.id) ||
            !(publisherPrefix === null || publisherPrefix === void 0 ? void 0 : publisherPrefix.value) ||
            !canViewPublisherPrefix)
            return (publisherPrefix === null || publisherPrefix === void 0 ? void 0 : publisherPrefix.value) || "";
        return (React.createElement(TextLink, { onClick: function () {
                return history.push("/bragency/publisher-prefixes/detail?id=".concat(publisherPrefix.id));
            } }, publisherPrefix.value));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.detail.pane.title" })),
        React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
        React.createElement(AccordionSet, null,
            React.createElement(AccordionSection, { id: "general-info", labelId: "ui-br-agency.product-number.accordions.label.general", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.detail.publisher" }), value: renderPublisherLink() }))),
                React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.detail.title" }), value: renderTitleLink() }))),
                React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.detail.product" }), value: renderProductLink() }))),
                React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.detail.publisherPrefix" }), value: renderPublisherPrefixLink() }))),
                React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.product-number.detail.agency", value: ((_d = (_c = (_b = productNumber.publisherPrefix) === null || _b === void 0 ? void 0 : _b.publisherPrefixRange) === null || _c === void 0 ? void 0 : _c.agencyPrefix) === null || _d === void 0 ? void 0 : _d.value) || "" }))),
                React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.product-number.detail.format", value: ((_f = (_e = productNumber.product) === null || _e === void 0 ? void 0 : _e.form) === null || _f === void 0 ? void 0 : _f.description) || "" }))),
                React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.product-number.detail.productNumber", value: productNumber.fullFormattedValue }))),
                productNumber.note && (React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.product-number.detail.note", value: productNumber.note })))),
                React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Checkbox, { checked: productNumber.blocked || false, disabled: true, label: intl.formatMessage({
                                id: "ui-br-agency.product-number.detail.blocked",
                            }) }))),
                productNumber.blocked && productNumber.blockReason && (React.createElement(Row, { style: { marginBottom: "25px" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.product-number.detail.blockReason", value: getBlockReasonTranslation(intl, productNumber.blockReason) })))),
                productNumber.blocked && productNumber.blockComment && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.product-number.detail.blockComment", value: productNumber.blockComment }))))))));
};
export default ProductNumberDetail;
